export const SET_SUBSCRIPTIONS_PLANS = '@subscriptions/SET_SUBSCRIPTIONS_PLANS';
export const SET_CURRENCY = '@subscriptions/SET_CURRENCY';
